import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export interface DecodedToken {
  id: string;
  username: string;
  roles: string[];
}



export const decodeToken = async (
    requiredAdmin?: boolean,
    minimumRoleLevel?: number,
    allowedRoles?: string[]
  ) => {
    try {
      const token = Cookies.get('token');

      // No secret is sent from the client — the server verifies the token's
      // signature with its own key. The JWT signing secret must never live here.
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/decrypt-token`, {
        token,
        requiredAdmin,
        minimumRoleLevel,
        allowedRoles,
      });
  
      return response.data;
    } catch (error: any) {
      console.error('Authorization failed:', error);
      const message = error?.response?.data?.message || 'Unknown error';
      return { authorized: false, message };
    }
  };


  export const decode = () => {
    const token = Cookies.get('token');
    if (!token) {
      return null;
    }
  
    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      console.error('Failed to decode token:', error);
      return null;
    }
  }
  
